import React from "react";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Stack, Typography } from "@mui/material";
import { WorkspaceIcon } from "assets/material-custom-icons";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { DealBase, IFolder } from "store/types";

import { Folder } from "./Folder";

interface IFolderSelectProps {
  deal: DealBase | null;
  folders: IFolder[];
  loading: boolean;
  selectedFolder: IFolder | null;
  setSelectedFolder: (folder: IFolder | null) => void;
  onCreateNewFolder: () => void;
  onStepBack: () => void;
  hasNewFolder: boolean;
  isGeneralDocument?: boolean;
}

export const FolderSelect: React.FC<IFolderSelectProps> = ({
  deal,
  folders,
  loading,
  selectedFolder,
  setSelectedFolder,
  onCreateNewFolder,
  onStepBack,
  hasNewFolder,
  isGeneralDocument
}) => {
  return (
    <AsyncContentMui isLoading={loading} spinnerProps={{ size: 30 }}>
      {isGeneralDocument && (
        <Stack
          direction="row"
          alignItems="center"
          gap="5px"
          maxWidth="450px"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          sx={{ paddingLeft: "5px", width: "fit-content" }}
          onClick={onStepBack}
        >
          <KeyboardArrowLeftIcon sx={{ fill: "#0A3142", cursor: "pointer" }} />
          <MaterialTooltip title={deal?.title} placement="top">
            <Typography
              sx={{
                fontSize: "16px",
                color: "#0a3142",
                cursor: "pointer",
                fontWeight: "700",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden"
              }}
            >
              {deal?.title}
            </Typography>
          </MaterialTooltip>
        </Stack>
      )}
      <Stack>
        <Stack
          sx={{
            border: "1px solid  #DBE8F5",
            padding: "10px",
            height: "250px",
            overflow: "scroll",
            marginBottom: "10px"
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            sx={{ height: "40px", borderBottom: "1px solid  #DAE0E2", maxWidth: "450px", width: "100%" }}
          >
            <Stack direction="row" alignItems="center" gap="10px" sx={{ paddingLeft: "10px" }}>
              <WorkspaceIcon sx={{ fill: "#0A3142" }} />
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "#0a3142",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                }}
              >
                Workspace
              </Typography>
            </Stack>
          </Stack>
          {folders.map((folder) => (
            <Folder
              key={folder.id}
              folder={folder}
              subIndex={1}
              setSelectedFolder={setSelectedFolder}
              selectedFolder={selectedFolder}
            />
          ))}
        </Stack>
        {!hasNewFolder && (
          <Typography
            sx={{ color: "#26A6AE", cursor: "pointer", width: "fit-content" }}
            onClick={onCreateNewFolder}
            data-create-folder
          >
            Add Folder
          </Typography>
        )}
      </Stack>
    </AsyncContentMui>
  );
};
